export const presignMessagePrefix="Ethereum Signed Message:\n";